import React from 'react'
import BuyingPoSourcingQueuePage from
  'domains/buying/deals/pages/po-sourcing-queue/buying-po-sourcing-queue-page'

import BuyingPoSourcingPage from
  'domains/buying/deals/pages/po-sourcing-queue/buying-po-sourcing-page'
import Phase3ProductQueuePage from 'domains/phase3-inbound-journey/pages/Phase3ProductQueuePage'
import { PHASE3_PRODUCT_SCOPES } from 'domains/phase3-inbound-journey/constants'
import { ConsignorSettlementDetailPage, ConsignorSettlementsListPage } from 'domains/consignor-settlements/pages'

const BUYING_SETTLEMENT_ROLES = [ 'owner', 'admin', 'purchasing' ]
const BUYING_SETTLEMENT_EMAILS = [ 'jac@belleandkate.com' ]

const buying_team_routes = {
  collapse  : true,
  name      : 'Buying Team',
  icon      : 'fas fa-shopping-cart text-orange',
  state_key : 'purchasing_team_collapse',
  views     : [
    {
      collapse  : true,
      name      : 'Seller (PO / BKO)',
      miniName  : 'PO',
      state_key : 'purchasing_seller_collapse',
      views     : [
        {
          path      : '/buying/inbound-journey/bko-appraisal',
          name      : 'BKO Appraisal Edit',
          miniName  : 'BA',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_NEEDED } title='BKO Appraisal Edit' apiNamespace='buying' />,
          layout    : '/app',
          invisible : true
        },
        {
          path      : '/buying/po-sourcing',
          name      : 'PO Sourcing Queue',
          miniName  : 'PQ',
          component : BuyingPoSourcingQueuePage,
          layout    : '/app'
        },
        {
          path          : '/buying/po-settlement',
          name          : 'PO Settlement',
          miniName      : 'PS',
          component     : (props) => <ConsignorSettlementsListPage { ...props } canNegotiate canSync settlementKind='seller' detailBasePath='/app/buying/po-sourcing/settlement' teamLabel='Buying Team' />,
          layout        : '/app',
          allowedRoles  : BUYING_SETTLEMENT_ROLES,
          allowedEmails : BUYING_SETTLEMENT_EMAILS
        },
        {
          path         : '/buying/po-sourcing/settlement/:id',
          name         : 'Seller Settlement Detail',
          component    : (props) => (
            <ConsignorSettlementDetailPage
              { ...props }
              canNegotiate={ true }
              canFinanceTransfer={ false }
              settlementKind='seller'
              listPath='/app/buying/po-settlement'
              teamLabel='Buying Team'
            />
          ),
          layout       : '/app',
          allowedRoles  : BUYING_SETTLEMENT_ROLES,
          allowedEmails : BUYING_SETTLEMENT_EMAILS,
          invisible     : true
        },
        {
          path      : '/buying/po-sourcing/:id',
          name      : 'PO Sourcing Detail',
          component : BuyingPoSourcingPage,
          layout    : '/app',
          invisible : true
        }
      ]
    }
  ]
}

export default buying_team_routes
